import "../styles/vertical-images.css";

// Import ảnh
import img1 from "../assets/img/vertical-images/banner-dien-vien-thieu-nhi.jpg";
import img2 from "../assets/img/vertical-images/banner-nha-thiet-ke-tuong-lai.jpg";
import img3 from "../assets/img/vertical-images/banner-phim-hoat-hinh-ai.jpg";
import img4 from "../assets/img/vertical-images/banner-sang-tao-my-thuat-thieu-nhi.jpg";

const imageUrls = [img1, img2, img3, img4];

const VerticalImages = () => {
  return (
    <div className="vertical-images-bg">
      <div className="vertical-images">
        {imageUrls.map((url, index) => (
          <img
            key={index}
            src={url}
            alt={`Vertical-images ${index + 1}`}
            className="vertical-images-image"
          />
        ))}
      </div>
    </div>
  );
};

export default VerticalImages;
